const isDefualtCurrency = (currency) => currency === 'USD';
export default isDefualtCurrency;
